<template>
    <div class="position-box">
        <div class="head">
            <img class="back" src="@/assets/icon_back.png" @click="back" alt="">
            <div class="title">{{$t('xyf.title')}}</div>
        </div>
        <div class="cotainer">
          <div class="credit-wrap">
            <div class="credit-box" :class="{ 'two': creditLevel == 2,'three': creditLevel == 3 }">
              <div class="t1">{{credit}}</div>
              <div class="t2" v-if="creditLevel == 1">{{$t('gjrz.jc')}}</div>
              <div class="t2" v-else-if="creditLevel == 2">{{$t('gjrz.yx')}}</div>
              <div class="t2" v-else>{{$t('gjrz.jc')}}</div>
              <!-- <div class="t3">{{$t('xyf.pgsj')}} {{credit_time | timeGs2}}</div> -->
            </div>
          </div>
          <!-- <div class="credit-box" v-show="credit">
              <div class="text t1">{{$t('xyf.title')}}</div>
              <div class="GaugeMeter" id="PreviewGaugeMeter_2" data-percent="10" data-append="" data-size="250" data-theme="#2CAADE" data-back="RGBa(0,0,0,.1)" data-animate_gauge_colors="1" data-animate_text_colors="1" data-width="10" data-label="" data-style="Full" data-label_color="#fff"></div>
              <div class="text t2">{{credit_name}}</div>
              <div class="text t3">{{$t('xyf.pgsj')}}</div>
              <div class="text t4">{{credit_time | timeGs2}}</div>
          </div> -->
        </div>
    </div>
</template>

<script>
// import '../utils/jquery.AshAlom.gaugeMeter-2.0.0.min.js'
export default {
    name: 'credit',
    data () {
      return {
        token: '',
        credit: '',
        credit_name: '',
        credit_time: '',
        creditLevel: 1,
        theme: false
      }
    },
    created(){
      this.theme = JSON.parse(localStorage.getItem('theme'));
      this.token = localStorage.getItem('token') || '';
    },
    mounted() {
        this.getInfo()
    },
    methods: {
      back(){
          this.$router.push('/index')
      },
      getInfo(){
        let params = {
            token: this.token
        }
        this.$ajax.get('/web/info',{params}).then((res) => {
          if(res.data.code == 1000){
            if(window.ethereum){
              this.$router.push('/index');
            }else{
              this.$router.push('/login');
            }
            return false;
          }
            let resData = res.data.data;
            this.credit = resData.credit;
            this.credit_name = resData.credit_name;
            this.credit_time = resData.credit_time;
            if(resData.credit < 600){
              this.creditLevel = 1
            }else if(resData.credit >= 600){
              this.creditLevel = 2
            }
        }).catch(function(err){
            console.log(err)
        })
      }
    },
    beforeDestroy(){

    }
}
</script>
<style scoped>
  .position-box{
        position: absolute;
        left: 0;
        top: 0;
        bottom: 0;
        width: 100%;
        height: auto;
        color: #cecece;
        font-size: .36rem;
        background: url('../assets/element-background.png') no-repeat center center;
        background-size: cover;
        overflow: hidden;
    }
    .head{
        position: fixed;
        top: 0;
        width: 100%;
        height: 1.2rem;
        padding: 0 .3rem;
        color: #fff;
        line-height: 1.2rem;
        box-sizing: border-box;
        text-align: center;
    }
    .head .back{
        position: absolute;
        left: .4rem;
        top: 50%;
        width: .3rem;
        margin-top: -.3rem;
    }
    .head .title{
        font-size: .56rem;
    }
    .head .text{
        font-size: .48rem;
    }
    .cotainer{
        position: absolute;
        top: 1.2rem;
        bottom: 0;
        width: 100%;
        background: transparent;
        overflow-y: scroll;
    }
    .credit-wrap{
      padding: 1rem 0;
    }
    .credit-box{
      position: relative;
      width: 7rem;
      height: 5rem;
      margin: 0 auto;
      background: url('../assets/new/xyf1.png') no-repeat center center;
      background-size: 100% 100%;
      text-align: center;
    }
    .credit-box.two{
      background: url('../assets/new/xyf3.png') no-repeat center center;
      background-size: 100% 100%;
    }
    .credit-box.three{
      background: url('../assets/new/xyf3.png') no-repeat center center;
      background-size: 100% 100%;
    }
    .credit-box .t1{
      width: 100%;
      padding: 2.3rem 0 .2rem;
      color: #00bb88;
      font-size: 1.2rem;
      font-weight: bold;
      text-align: center;
    }
    .credit-box .t2{
      color: #00bb88;
      font-size: .56rem;
    }
    .credit-box .t3{
      margin-top: .2rem;
      color: #aaa;
      font-size: .36rem;
    }
</style>



// WEBPACK FOOTER //
// src/pages/credit.vue